import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			component: function(resolve) {
				require(['../components/home'], resolve);
			}
		}, {
			path: '/home',
			component: function(resolve) {
				require(['../components/home'], resolve);
			}
		},
		{
			path: '/hotellist',
			component: function(resolve) {
				require(['../components/hotellist'], resolve);
			}
		},
		{
			path: '/hotelDetail',
			component: function(resolve) {
				require(['../components/hotelDetail'], resolve);
			}
		},
		{
			path: '/hotelOrderFilling',
			component: function(resolve) {
				require(['../components/hotelOrderFilling'], resolve);
			}
		},
		{
			path: '/orderSuccess',
			component: function(resolve) {
				require(['../components/orderSuccess'], resolve);
			}
		},
		{
			path: '/hotelOrderlist',
			component: function(resolve) {
				require(['../components/userCenter/hotelOrderlist'], resolve);
			}
		},
		{
			path: '/unpaidBill',
			component: function(resolve) {
				require(['../components/userCenter/unpaidBill'], resolve);
			}
		},
		{
			path: '/billDetail',
			component: function(resolve) {
				require(['../components/billDetail'], resolve);
			}
		},
		{
			path: '/accountSetting',
			component: function(resolve) {
				require(['../components/userCenter/mySetting'], resolve);
			}
		},
		{
			path: '/favorites',
			component: function(resolve) {
				require(['../components/userCenter/favorites'], resolve);
			}
		},
		{
			path: '/notice',
			component: function(resolve) {
				require(['../components/notice'], resolve);
			}
		},
		{
			path: '/hotelOrderDetail',
			component: function(resolve) {
				require(['../components/hotelOrderDetail'], resolve);
			}
		},
		{
			path: '/groupHotelOrderDetail',
			component: function(resolve) {
				require(['../components/groupOrderDetail'], resolve);
			}
			
		},
		{
			path: '/groupOrderModify',
			component: function(resolve) {
				require(['../components/groupOrderModify'], resolve);
			}			
		},
		{
			path: '/groupPrint',
			component: function(resolve) {
				require(['../components/groupPrint'], resolve);
			}
		},
		{
			path: '/hotelGetTrip',
			component: function(resolve) {
				require(['../components/hotelGetTrip'], resolve);
			}
		},
		{
			path: '/hotelPrint',
			component: function(resolve) {
				require(['../components/hotelPrint'], resolve);
			}
		},
		{
			path: '/groupOrder',
			component: function(resolve) {
				require(['../components/userCenter/groupOrder'], resolve);
			}
		},
		{
			path: '/personnelManagement',
			component: function(resolve) {
				require(['../components/userCenter/manager'], resolve);
			}
		},
		{
			path: '/cooperationAgreement',
			component: function(resolve) {
				require(['../components/userCenter/agreement'], resolve);
			}
		},
		{
			path: '/registerAgree',
			component: function(resolve) {
				require(['../components/login/registerAgree'], resolve);
			}
		},
		{
			path: '/dynamicQuotation',
			component: function(resolve) {
				require(['../components/dynamicQuotation'], resolve);
			}
		},
		{
			path: '/hotelGroup',
			component: function(resolve) {
				require(['../components/hotelGroup'], resolve);
			}
		},
		{
			path: '/login',
			component: function(resolve) {
				require(['../components/login/login'], resolve);
			},
			children: [{
					path: 'loginHome',
					component: function(resolve) {
						require(['../components/login/loginHome'], resolve);
					},
				},
				{
					path: 'forgetPassWord',
					component: function(resolve) {
						require(['../components/login/forgetPassWord'], resolve);
					},
				},
				{
					path: 'forgetPwNext',
					component: function(resolve) {
						require(['../components/login/forgetPwNext'], resolve);
					},
				},
				{
					path: 'register',
					component: function(resolve) {
						require(['../components/login/register'], resolve);
					},
				},
				{
					path: 'registerSucceed',
					component: function(resolve) {
						require(['../components/login/registerSucceed'], resolve);
					},
				},
			]
		},
	]
})


// WEBPACK FOOTER //
// ./docs/router/index.js